import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTimer } from "../../hooks/useCountDown";

import { GetConfirmLocationService, postConfirmLocationService, putConfirmLocationSerice } from "../../services/registerApi";
import { showErrorMessage } from "../../services/httpService";
import { toEnglishNumbers } from "../../utils/datePicker";
import { canTypeForNumInput } from "../../utils/numbers";
import { decodeToken } from "../../utils/decodeToken";
import { errorMessage, successMessage } from "../../utils/message";

import { Marker, TileLayer, MapContainer, useMapEvent } from "react-leaflet";
import { Icon } from "leaflet";
const skater = new Icon({
	iconUrl: `/img/side.svg`,
	iconSize: [25, 25],
});

const ConfirmLocation = () => {
	const navigate = useNavigate();
	const { executeRecaptcha } = useGoogleReCaptcha();
	const params = useParams();
	const { seconds, minutes, reset, isActive } = useTimer(120);

	const [openModal, setOpenModal] = useState(false);
	const [tokenCode, setTokenCode] = useState({ original: '', decoded: {} });
	const [codeMessage, setCodeMessage] = useState('');
	const [showLocation, setShowLocation] = useState(false);
	const [location, setLocation] = useState({
		cityLoc: {
			originLat: "31.88352203369140",
			originLng: "54.34774017333980",
			stateId: '',
		},
		fullName: "رضا آئینه کار",
		address: "صفاپیه بلوار دانشگاه درب فناوری دانشگاه یزد ساختمان نوآوری و فناوری ۲ اتاق ۵۲۲",
		postalCode: "۸۹۴۲۱۵۷۴",
	});

	const handleReCaptchaVerify = useCallback(async () => {
		if (!executeRecaptcha) {
			return;
		}
		const token = await executeRecaptcha();
		return token;
	}, [executeRecaptcha]);

	useEffect(() => {
		getConfirmLocation();
	}, []);

	const getConfirmLocation = async (isReset = false) => {
		if (showLocation) return;

		const recaptchaToken = await handleReCaptchaVerify();
		const res = await GetConfirmLocationService(params.locationId, recaptchaToken);
		if (res.error) {
			return showErrorMessage(res);
		} else {
			setTokenCode({ original: res.data.tokenCode, decoded: decodeToken(res.data.tokenCode) });
			successMessage(res.data.message);

			var d1 = new Date();
			var d2 = new Date(decodeToken(res.data.tokenCode).date);

			var diff = (d2.getTime() - d1.getTime()) / (1000);
			isReset ? reset() : reset(diff);
		}
	};
	const postConfirmLocation = async () => {
		if (!codeMessage) return errorMessage("لطفا کد پیامک شده به شماره همراه خود را وارد کنید");
		const recaptchaToken = await handleReCaptchaVerify();
		const res = await postConfirmLocationService(
			{
				phoneNumber: tokenCode.decoded.phoneNumber,
				code: codeMessage,
				tokenCode: tokenCode.original,
				token: params.locationId
			},
			recaptchaToken
		);

		if (res.error) return showErrorMessage(res);

		setShowLocation(true);
		setLocation(res.data);
	};
	const hadleConfirmLocation = async () => {
		const recaptchaToken = await handleReCaptchaVerify();
		const { data, status } = await putConfirmLocationSerice(
			location.cityLoc.originLat,
			location.cityLoc.originLng,
			params.locationId,
			recaptchaToken
		);
		if (status) {
			setOpenModal(false);
			successMessage('موقعیت مکانی شما باموفقیت ثبت شد');
			navigate("/", { replace: true });
		}
	};
	const SetViewOnClick = () => {
		const map = useMapEvent('click', (e) => {
			setLocation(prev => ({
				...prev, cityLoc: {
					...prev.cityLoc,
					originLat: e.latlng.lat,
					originLng: e.latlng.lng
				}
			}));
			map.setView(e.latlng, map.getZoom());
		});

		return null;
	};

	return (
		<section className="container container--location">
			<main className="main__container--determining">
				<div className="location__card ">
					<div className="location__main">
						<img
							src="/img/location.svg"
							alt="location"
							className="location__address-img"
						/>
						<h3 className="location__title">تایید موقعیت مکانی </h3>
					</div>

					{showLocation ? (
						<>
							<div className="confirm-location__info">
								<label>نام و نام خانوادگی:</label>
								<span>{location.fullName}</span>
							</div>
							<div className="confirm-location__info">
								<label>آدرس:</label>
								<span>{location.address}</span>
							</div>
							<div className="confirm-location__info">
								<label>کدپستی:</label>
								<span>{location.postalCode}</span>
							</div>

							<p style={{ fontSize: "14px", color: "#444", padding: "2rem 0 1rem", fontWeight: 'bold' }}>
								لطفا موقعیت مکانی آدرس بالا را روی نقشه مشخص کنید:
							</p>

							{/* rect leaflet */}
							<div className="location__map">
								<MapContainer
									center={[location.cityLoc.originLat, location.cityLoc.originLng]}
									zoom={13}
									scrollWheelZoom={false}
									style={{ width: "100%", height: "100%", flex: "0 0 auto" }}
								>

									<TileLayer
										attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
										url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
									/>
									<SetViewOnClick />
									<Marker
										position={[location.cityLoc.originLat, location.cityLoc.originLng]}
										icon={skater}
									></Marker>
								</MapContainer>
							</div>
						</>
					) : (
						<form style={{ width: '100%' }}>
							<p
								className="login__content-text"
								style={{ color: '#333' }}
							>
								لطفا کد ارسال شده به شماره همراه خود را وارد کنید
							</p>

							{isActive ? (
								<div
									style={{
										display: "flex",
										fontSize: "1.4rem",
										marginBottom: "1rem",
										justifyContent: "center",
									}}
								>
									<p style={{ color: "#fe941a", minWidth: '40px' }}>{`${seconds} : ${minutes}`}</p>
									<p style={{ color: "#21164b", marginRight: ".75rem" }}>
										مانده تا دریافت مجدد کد
									</p>
								</div>
							) : (
								<p
									onClick={() => getConfirmLocation(true)}
									style={{
										textAlign: "center",
										fontSize: "1.3rem",
										marginBottom: "1rem",
										color: "#21164b",
										cursor: "pointer"
									}}
								>
									ارسال مجدد کد{" "}
								</p>
							)}

							<label
								htmlFor="login__content-section"
								className="login__content-section"
								style={{ padding: '0 3rem' }}
							>
								<input
									className="login__content-input"
									style={{ textAlign: 'center', fontSize: '2rem', color: '#444' }}
									type="number"
									name="phone"
									value={codeMessage}
									onChange={(e) => setCodeMessage(toEnglishNumbers(e.target.value))}
									onKeyDown={(e) => {
										canTypeForNumInput(e);
										if (e.key === 'Enter') postConfirmLocation();
									}}
								/>
								<span className="login__content-focus"></span>
							</label>
						</form>
					)}
				</div>

				<button
					className="login__content-btn"
					style={{ maxWidth: '140px' }}
					onClick={showLocation ? () => setOpenModal(true) : postConfirmLocation}
				>
					{showLocation ? 'تایید موقعیت' : 'تایید و ادامه'}
				</button>
			</main>

			{openModal && (
				<div className="modal">
					<div className="modal__content">
						<img
							src="/img/delete.png"
							alt="close"
							className="modal__img"
							style={{ cursor: 'pointer' }}
							onClick={() => setOpenModal(false)}
						/>
						<p className="modal__price">
							مختصات تعیین شده دیگر قابل تغییر نمی باشد. از مختصات خود مطمئن
							هستید؟
						</p>
						<div className="modal__btns">
							<button
								className="btn btn--secondary btn--secondary-modal btn--secondary-modal--cancel"
								onClick={() => setOpenModal(false)}
							>
								انصراف
							</button>
							<button
								className="btn btn--secondary btn--secondary-modal btn--secondary-modal--submit"
								onClick={hadleConfirmLocation}
							>
								تایید
							</button>
						</div>
					</div>
				</div>
			)}
		</section >
	);
};

export default ConfirmLocation;
